import { ComponentProps, ReactElement } from 'react';

import { getClasses } from '@/utils';

export type InvoicePdfDetailProps = ComponentProps<'li'> & { name?: string; bold?: boolean };

const InvoicePdfDetail = ({ name, bold, children, ...props }: InvoicePdfDetailProps): ReactElement => (
  <li {...props} className={getClasses('InvoicePdf-Detail', props.className)}>
    {name && (
      <strong style={{ fontWeight: bold ? 'bold' : 'normal' }}>
        {name}
        {children ? ':' : ''}
      </strong>
    )}{' '}
    {children && <span>{children}</span>}
  </li>
);

export default InvoicePdfDetail;
